import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectTeacherProfileRetrieval = createSelector(
  [(state: AppState) => state.teacher.profileRetrieval],
  ({ data, fetching }) => ({
    data,
    fetching,
  }),
);
